import React from 'react'
import { Form, FormGroup, Label } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FormItem from '../../../../common/forms/FormItem';
import Loader from '../../../../common/Loader';
import TextInput from '../../../../common/forms/input/TextInput';
import { isRequired } from '../../../../../utils/validators';
import LocationSelect from '../../../../common/forms/select/LocationSelect';
import FormFooter from '../../../../common/forms/FormFooter';
import RouteSelect from '../../../../common/forms/select/RouteSelect';

const BoardingGroupForm = ({
  handleSubmit,
  loading,
  isEdit
}) => {
  if (loading) return <Loader />;
  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Nombre" required>
          <Field
            name="name"
            component={TextInput}
            placeholder="Nombre"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Ruta" required>
          <Field
            name="route"
            component={RouteSelect}
            placeholder="Ruta"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Ubicaciones" required>
          <Field
            name="locationList"
            component={LocationSelect}
            validate={[isRequired]}
            isMulti
          />
        </FormItem>
      </FormGroup>
      {isEdit && (
        <FormGroup row>
          <FormItem label="Estado">
            <Label>
              <Field name="active" component="input" type="checkbox" /> Activo
            </Label>
          </FormItem>
        </FormGroup>
      )}
      <FormFooter />
    </Form>
  )
}

BoardingGroupForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  isEdit: PropTypes.bool.isRequired
};

const mapStateToProps = ({
  ItineraryUnit,
}) => ({
  loading: !ItineraryUnit.BoardingGroup.getIn(['current', 'activity']).isEmpty(),
})

const formComponent = reduxForm({
  form: 'boardingGroupForm',
})(BoardingGroupForm);

export default connect(mapStateToProps)(formComponent);
